// assets
import LasVegas from "src/assets/images/home/las_vegas.png";
import Newyork from "src/assets/images/home/newyork.png";
import Atlantas from "src/assets/images/home/atlantas.png";
import Boston from "src/assets/images/home/boston.png";

import Event1 from "src/assets/images/home/to_delete1.png";
import Event2 from "src/assets/images/home/to_delete2.png";
import Event3 from "src/assets/images/home/to_delete3.png";
import Event4 from "src/assets/images/home/to_delete4.png";
import Event5 from "src/assets/images/home/to_delete5.png";
import Event6 from "src/assets/images/home/to_delete6.png";

import BlogImg1 from "src/assets/images/blog/blog-img-1.png";
import BlogImg2 from "src/assets/images/blog/blog-img-2.png";

import CategoryFamily from "src/assets/images/home/to_delete7.png";
import CategoryEntertainment from "src/assets/images/home/to_delete8.png";
import CategoryMusic from "src/assets/images/home/to_delete9.png";
import CategoryActivities from "src/assets/images/home/activities.png";
import CategoryBusiness from "src/assets/images/home/buisness.jpeg";
import CategoryTech from "src/assets/images/home/tech.jpeg";
import CategoryGames from "src/assets/images/home/games.jpeg";
import CategoryHealth from "src/assets/images/home/health.jpeg";
import CategoryVirtual from "src/assets/images/home/virtual.jpeg";
import CategorySport from "src/assets/images/home/sport.jpeg";
import CategoryToday from "src/assets/images/home/today.jpeg";
import CategoryTomorrow from "src/assets/images/home/tomorrow.png";
import CategoryWeekend from "src/assets/images/home/weekend.png";

// advertisment images
import ADImgOne from "src/assets/images/home-advertisment/ad-1.png";
import ADImgTwo from "src/assets/images/home-advertisment/ad-2.png";
import ADImgThree from "src/assets/images/home-advertisment/ad-3.png";
import ADImgFour from "src/assets/images/home-advertisment/ad-4.png";
import ADImgFive from "src/assets/images/home-advertisment/ad-5.jpeg";

export default {
  empty_3: [{}, {}, {}, {}],
  empty_12: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
  temp_img: BlogImg1,
  tags: [
    {
      Categoryid: -4,
      CategoryName: "This Weekend",
      Discription: "",
    },
    {
      Categoryid: 1,
      CategoryName: "Entertainment",
      Discription: "",
    },
    {
      Categoryid: 2,
      CategoryName: "Music",
      Discription: "",
    },
    {
      Categoryid: 3,
      CategoryName: "Activities",
      Discription: "",
    },
    {
      Categoryid: 4,
      CategoryName: "Family",
      Discription: "",
    },
    {
      Categoryid: 5,
      CategoryName: "Business",
      Discription: "",
    },
    {
      Categoryid: 6,
      CategoryName: "Tech",
      Discription: "",
    },
    {
      Categoryid: 7,
      CategoryName: "Games",
      Discription: "",
    },
    {
      Categoryid: 8,
      CategoryName: "Health",
      Discription: "",
    },
    {
      Categoryid: 9,
      CategoryName: "Virtual",
      Discription: "",
    },
    {
      Categoryid: 10,
      CategoryName: "Sports",
      Discription: "",
    },
  ],
  init_categories: [
    {
      Categoryid: -3,
      CategoryName: "Feed",
      Discription: "",
    },
    {
      Categoryid: -1,
      CategoryName: "Today",
      Discription: "",
    },
    {
      Categoryid: -2,
      CategoryName: "Tomorrow",
      Discription: "",
    },
  ],
  event_search: {
    events: [
      {
        city: "Las Vegas",
        state: "Nevada",
        imgpath: LasVegas,
        lat: 36.1699412,
        lng: -115.1398296,
      },
      {
        city: "New York",
        state: "stathue",
        imgpath: Newyork,
        lat: 40.7127753,
        lng: -74.0059728,
      },
      {
        city: "Atlanta",
        state: "Nevada",
        imgpath: Atlantas,
        lat: 33.7489954,
        lng: -84.3879824,
      },
      {
        city: "Boston",
        state: "Nevada",
        imgpath: Boston,
        lat: 42.3600825,
        lng: -71.0588801,
      },
    ],
    venue: [
      {
        name: "TEATTERIRAVINTOLA LASITERASSI",
        state: "Nevada",
        distance: "15 miles away",
      },
      {
        name: "TEATTERIRAVINTOLA LASITERASSI",
        state: "Nevada",
        distance: "15 miles away",
      },
      {
        name: "TEATTERIRAVINTOLA LASITERASSI",
        state: "Nevada",
        distance: "15 miles away",
      },
      {
        name: "TEATTERIRAVINTOLA LASITERASSI",
        state: "Nevada",
        distance: "15 miles away",
      },
    ],
  },
  recent_events: [
    {
      id: 1,
      title: "Lindy Harvest",
      time: "This Saturday 11:00 AM",
      imagePath: Event1,
    },
    {
      id: 2,
      title: "Holiday Festival at Coe Hall",
      time: "Thursday, December 9th",
      imagePath: Event2,
    },
    {
      id: 3,
      title: "Fall Cleanup at Hallockville",
      time: "This Saturday, 9:00 AM",
      imagePath: Event3,
    },
    {
      id: 4,
      title: "DREW FRASER",
      time: "Friday, November 26th",
      imagePath: Event4,
    },
    {
      id: 5,
      title: "MITCH FATEL - SPECIAL EVENT",
      time: "This Thursday, 8:00 PM",
      imagePath: Event5,
    },
    {
      id: 6,
      title: "ERIC D'ALESSANDRO - SPECIAL EVENT (P)",
      time: "This Saturday 7:00 PM",
      imagePath: Event6,
    },
  ],
  blog: [
    {
      id: 1,
      BlogTitle: "Museum of paris with great art peaces and structher",
      BlogDescription:
        "weather in person or Hybrid events are useful in sharing all or part of a face-to-face event with attendees who cannot make i",
      BlogLink: "/",
      BlogImage: BlogImg1,
    },
    {
      id: 2,
      title: "“Music in the soul can be heard by the universe”",
      overview:
        "weather in person or Hybrid events are useful in sharing all or part of a face-to-face event with attendees who cannot make i",
      to: "/",
      imgpath: BlogImg2,
    },
    {
      id: 3,
      title: "Museum of paris with great art peaces and structher",
      overview:
        "weather in person or Hybrid events are useful in sharing all or part of a face-to-face event with attendees who cannot make i",
      to: "/",
      imgpath: BlogImg1,
    },
    {
      id: 4,
      title: "“Music in the soul can be heard by the universe”",
      overview:
        "weather in person or Hybrid events are useful in sharing all or part of a face-to-face event with attendees who cannot make i",
      to: "/",
      imgpath: BlogImg2,
    },
    {
      id: 5,
      title: "Museum of paris with great art peaces and structher",
      overview:
        "weather in person or Hybrid events are useful in sharing all or part of a face-to-face event with attendees who cannot make i",
      to: "/",
      imgpath: BlogImg1,
    },
    {
      id: 6,
      title: "“Music in the soul can be heard by the universe”",
      overview:
        "weather in person or Hybrid events are useful in sharing all or part of a face-to-face event with attendees who cannot make i",
      to: "/",
      imgpath: BlogImg2,
    },
  ],
  by_category: [
    // {
    //   image: CategoryToday,
    //   data: {
    //     Categoryid: -1,
    //     CategoryName: "Today",
    //     Discription: "",
    //   },
    // },
    // {
    //   image: CategoryTomorrow,
    //   data: {
    //     Categoryid: -2,
    //     CategoryName: "Tomorrow",
    //     Discription: "",
    //   },
    // },
    {
      image: CategoryWeekend,
      data: {
        Categoryid: -4,
        CategoryName: "This Weekend",
        Discription: "",
      },
    },
    {
      image: CategoryEntertainment,
      data: {
        Categoryid: 1,
        CategoryName: "Entertainment",
        Discription: "",
      },
    },
    {
      image: CategoryMusic,
      data: {
        Categoryid: 2,
        CategoryName: "Music",
        Discription: "",
      },
    },
    {
      image: CategoryActivities,
      data: {
        Categoryid: 3,
        CategoryName: "Activities",
        Discription: "",
      },
    },
    {
      image: CategoryFamily,
      data: {
        Categoryid: 4,
        CategoryName: "Family",
        Discription: "",
      },
    },
    {
      image: CategoryBusiness,
      data: {
        Categoryid: 5,
        CategoryName: "Business",
        Discription: "",
      },
    },
    {
      image: CategoryTech,
      data: {
        Categoryid: 6,
        CategoryName: "Tech",
        Discription: "",
      },
    },
    {
      image: CategoryGames,
      data: {
        Categoryid: 7,
        CategoryName: "Games",
        Discription: "",
      },
    },
    {
      image: CategoryHealth,
      data: {
        Categoryid: 8,
        CategoryName: "Health",
        Discription: "",
      },
    },
    {
      image: CategoryVirtual,
      data: {
        Categoryid: 9,
        CategoryName: "Virtual",
        Discription: "",
      },
    },
    {
      image: CategorySport,
      data: {
        Categoryid: 10,
        CategoryName: "Sports",
        Discription: "",
      },
    },
    {
      image: CategoryMusic,
      data: {
        Categoryid: 11,
        CategoryName: "Party",
        Discription: "",
      },
    },
  ],
  states: [
    {
      name: "Ahmedpur town",
      lat: "41.3083",
      lng: "-72.9279",
    },
    {
      name: "Yazman, Mandi 123",
      lat: "41.3083",
      lng: "-72.9279",
    },
    {
      name: "Bahawalpur, 23",
      lat: "41.3083",
      lng: "-72.9279",
    },
    {
      name: "Kolkata town",
      lat: "41.3083",
      lng: "-72.9279",
    },
    {
      name: "Tokyeo,strewf",
      lat: "41.3083",
      lng: "-72.9279",
    },
    {
      name: "Gtrewnled,erwt23",
      lat: "41.3083",
      lng: "-72.9279",
    },
  ],
};

export const advertismentSlider = [
  // ADImgOne,
  ADImgTwo,
  // ADImgThree,
  // ADImgFour,
  ADImgFive,
];

export const dashboard = [
  {
    id: 1,
    status: "failed",
    source: "Ticketmaster",
    time: "29 mins ago",
    run_time: "",
    fetched: 632,
    processed: 632,
    change: -15,
    isAffliate: 0,
    list: ["_error_field=photo", "_error_field=name", "_error_field=slug"],
  },
  {
    id: 2,
    status: "complete",
    source: "Stub hub",
    time: "",
    run_time: "8:30Pm",
    fetched: 435,
    processed: 419,
    change: 57,
    isAffliate: 1,
    list: [],
  },
  {
    id: 3,
    status: "complete",
    source: "Ticket now",
    time: "",
    run_time: "4:50Pm",
    fetched: 586,
    processed: 271,
    change: 32,
    isAffliate: 0,
    list: [],
  },
  {
    id: 4,
    status: "failed",
    source: "Ticketmaster",
    time: "29 mins ago",
    run_time: "",
    fetched: 632,
    processed: 632,
    change: -15,
    isAffliate: 1,
    list: ["_error_field=photo"],
  },
  {
    id: 5,
    status: "complete",
    source: "Stub hub",
    time: "",
    run_time: "8:30Pm",
    fetched: 435,
    processed: 419,
    change: 57,
    isAffliate: 1,
    list: [],
  },
  {
    id: 6,
    status: "complete",
    source: "Ticket now",
    time: "",
    run_time: "4:50Pm",
    fetched: 586,
    processed: 271,
    change: 32,
    isAffliate: 0,
    list: [],
  },
  {
    id: 1,
    status: "failed",
    source: "Ticketmaster",
    time: "29 mins ago",
    run_time: "",
    fetched: 632,
    processed: 632,
    change: -15,
    isAffliate: 0,
    list: ["_error_field=name", "_error_field=slug"],
  },
  {
    id: 2,
    status: "complete",
    source: "Stub hub",
    time: "",
    run_time: "8:30Pm",
    fetched: 435,
    processed: 419,
    change: 57,
    isAffliate: 0,
    list: [],
  },
  {
    id: 3,
    status: "complete",
    source: "Ticket now",
    time: "",
    run_time: "4:50Pm",
    fetched: 586,
    processed: 271,
    change: 32,
    isAffliate: 0,
    list: [],
  },
];
